import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Navbar } from '../components/Navbar';
import { Clock, ArrowRight, RefreshCw, AlertCircle } from 'lucide-react';
import { Button } from '../components/ui/button';

export const SubscriptionPending = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  
  // Parâmetros retornados pelo Mercado Pago
  const paymentId = searchParams.get('payment_id');
  const status = searchParams.get('status');

  return (
    <div className="min-h-screen bg-gradient-to-b from-amber-900 to-slate-900">
      <Navbar />
      
      <div className="max-w-2xl mx-auto px-6 py-16">
        <div className="bg-slate-800/50 backdrop-blur-sm rounded-2xl border border-amber-500/30 p-8 text-center">
          {/* Pending Icon */}
          <div className="w-20 h-20 bg-gradient-to-r from-amber-500 to-orange-500 rounded-full flex items-center justify-center mx-auto mb-6">
            <Clock className="w-10 h-10 text-white" />
          </div>

          {/* Title */}
          <h1 className="text-3xl font-bold text-white mb-4" data-testid="pending-title">
            Pagamento em Processamento
          </h1>

          {/* Message */}
          <p className="text-slate-300 text-lg mb-6">
            Seu pagamento está sendo processado. Isso pode levar alguns minutos ou 
            até 2 dias úteis dependendo do método de pagamento escolhido.
          </p>

          {/* Payment Details */}
          {paymentId && (
            <div className="bg-slate-700/50 rounded-lg p-4 mb-6 text-left">
              <h3 className="text-white font-medium mb-2">Detalhes do Pagamento</h3>
              <div className="space-y-1 text-sm">
                <p className="text-slate-400">
                  ID: <span className="text-white font-mono">{paymentId}</span>
                </p>
                <p className="text-slate-400">
                  Status: <span className="text-amber-400 font-medium">{status || 'pending'}</span>
                </p>
              </div>
            </div>
          )}

          {/* Info Box */}
          <div className="flex items-start gap-3 bg-amber-500/10 border border-amber-500/30 rounded-lg p-4 mb-6 text-left">
            <AlertCircle className="w-5 h-5 text-amber-400 flex-shrink-0 mt-0.5" />
            <div>
              <p className="text-amber-200 text-sm">
                <strong>Boleto ou PIX?</strong> Assim que o pagamento for confirmado, 
                você receberá um email e sua assinatura será ativada automaticamente.
              </p>
            </div>
          </div>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <Button
              onClick={() => navigate('/seller/dashboard')}
              className="bg-gradient-to-r from-amber-500 to-orange-500 hover:opacity-90"
              data-testid="go-to-dashboard-btn"
            >
              <span className="flex items-center gap-2">
                Ir para o Painel
                <ArrowRight className="w-4 h-4" />
              </span>
            </Button>
            <Button
              onClick={() => window.location.reload()}
              variant="outline"
              className="border-slate-600 text-white hover:bg-slate-700"
            >
              <span className="flex items-center gap-2">
                <RefreshCw className="w-4 h-4" />
                Verificar Status
              </span>
            </Button>
          </div>
        </div>

        {/* Timeline */}
        <div className="mt-8 bg-slate-800/30 rounded-xl p-6 border border-slate-700">
          <h3 className="text-white font-medium mb-4">O que acontece agora?</h3>
          <div className="space-y-4">
            <div className="flex items-start gap-3">
              <div className="w-8 h-8 bg-amber-500 rounded-full flex items-center justify-center text-white text-sm font-medium flex-shrink-0">
                1
              </div>
              <div>
                <p className="text-white font-medium">Pagamento em análise</p>
                <p className="text-slate-400 text-sm">Seu pagamento está sendo processado pelo Mercado Pago</p>
              </div>
            </div>
            <div className="flex items-start gap-3">
              <div className="w-8 h-8 bg-slate-600 rounded-full flex items-center justify-center text-white text-sm font-medium flex-shrink-0">
                2
              </div>
              <div>
                <p className="text-slate-400 font-medium">Confirmação do pagamento</p>
                <p className="text-slate-500 text-sm">Você receberá um email quando o pagamento for confirmado</p>
              </div>
            </div>
            <div className="flex items-start gap-3">
              <div className="w-8 h-8 bg-slate-600 rounded-full flex items-center justify-center text-white text-sm font-medium flex-shrink-0">
                3
              </div>
              <div>
                <p className="text-slate-400 font-medium">Ativação automática</p>
                <p className="text-slate-500 text-sm">Sua assinatura será ativada automaticamente</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
